export const SEARCH_CATEGORIES = {
  GALLERY: 'gallery',
  FAQ: 'faq',
  TOOLKIT: 'toolkit',
  ANNOUNCEMENTS: 'announcement',
  CLIENTS: 'client',
  PARTNERS: 'partners',
  DIRECTORY: 'directory',
} as const;

export const MIN_SEARCH_LENGTH = 2;
export type SearchCategoriesType = (typeof SEARCH_CATEGORIES)[keyof typeof SEARCH_CATEGORIES];
